/** @typedef {import('@/models/CreateProfile').createProfile} Profile */
import { supabase } from '@/lib/supabase';
import { createProfile } from '@/models/CreateProfile';

/**
 * DBからUsers取得
 * @param {string} userId
 * @returns {Promise<Map<number, Profile>>} idをキーとしたMap
 */
export async function getProfile(userId) {
  if (!userId) {
    console.log('ログインしてください。');
    return;
  }
  try {
    const { data, error } = await supabase.from('profiles').select('*').eq('id', userId).single();

    if (error) {
      throw error;
    } else {
      return createProfile(data);
    }
  } catch (error) {
    console.error('Error fetching users:', error);
    return;
  }
}

/**
 * ProfileをDBに追加
 * @param {object} user - ユーザーオブジェクト
 * @param {Profile} user - モデル化済みprofile
 * @returns {Promise<Profile>} DB登録後のProfile
 */
export async function addUserToDatabase(userId, user) {
  const { data, error } = await supabase
    .from('profiles')
    .insert({
      id: userId,
      username: user.username,
      updated_at: new Date().toISOString(),
    })
    .select();

  // insertの結果
  if (error) {
    console.error('Error adding user:', error);
    throw error;
  } else {
    console.log('inserted user:', data);
  }

  return createProfile(data[0]);
}

/**
 * Profileの内容を更新
 * @param {Object} form
 * @returns {Promise<Profile>}
 */
export async function updateProfile(form) {
  console.log(form);
  const { data, error } = await supabase
    .from('profiles')
    .update({
      role_id: form.role_id,
      username: form.username,
      birthday: form.birthday,
      updated_at: new Date().toISOString(),
    })
    .eq('id', form.id)
    .select();

  if (error) throw error;
  if (data.length == 0) {
    throw new Error('1件もデータがありませんでした。');
  }
  return createProfile(data[0]);
}

/**
 * Profileを削除（論理削除）
 * @param {Profile} profile
 * @returns {Promise<Profile>} 削除後のProfile
 */
export async function removeProfile(user) {
  if (!user.id) {
    throw new Error('User ID がありません');
  }
  const { data, error } = await supabase
    .from('profiles')
    .update({
      deleted_at: user.deletedAt,
      updated_at: new Date().toISOString(),
    })
    .eq('user_id', user.id)
    .select();

  if (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
  return createProfile(data[0]);
}
